// services/locations/getCities.js
import axiosInstance from '../axiosMiddleware';

export async function getCities(stateId) {
  try {
    const response = await axiosInstance.post('location/cities', { stateId });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}